import { Contrato } from './contrato.entity';
import { UsuarioOnline } from './UsuarioOnline.entity';

export class ContratosUser {
    Contratos: Contrato[];
    UsuarioOnline: UsuarioOnline;
    ContratoSeleccionado: number;
}